import { CartItemWithUUID } from "@swiggy-private/cart-types";
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionStealDealWidget = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    params: {
        cartId: string;
        originalCartId: string;
        items: CartItemWithUUID[];
        stealDealUnlocked: boolean;
    },
): void => {
    const items = params.items.map((item) => ({
        itemId: item.menu_item_id,
        originalPrice: item.base_price,
        discountedPrice: item.final_price,
    }));
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_STEAL_DEAL_WIDGET,
        extraParams: JSON.stringify({
            cartId: params.cartId,
            originalCartId: params.originalCartId,
            stealDealUnlocked: params.stealDealUnlocked,
        }),
        context: JSON.stringify({
            items: items,
        }),
    });
};

export const clickStealDealAddButtonEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    params: { cartId: string; originalCartId: string; item: CartItemWithUUID },
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_STEAL_DEAL_CLAIM_BUTTON,
        extraParams: JSON.stringify({ cartId: params.cartId, originalCartId: params.originalCartId }),
        context: JSON.stringify({
            itemId: params.item.menu_item_id,
            originalPrice: params.item.base_price,
            discountedPrice: params.item.final_price,
        }),
    });
};
